const provinces = [
  { value: "", text: "" },
  { value: "AC", text: "Acre (AC)" },
  { value: "AL", text: "Alagoas (AL)" },
  { value: "AP", text: "Amapá (AP)" },
  { value: "AM", text: "Amazonas (AM)" },
  { value: "BA", text: "Bahia (BA)" },
  { value: "CE", text: "Ceará (CE)" },
  { value: "DF", text: "Distrito Federal (DF)" },
  { value: "ES", text: "Espírito Santo (ES)" },
  { value: "GO", text: "Goías (GO)" },
  { value: "MA", text: "Maranhão (MA)" },
  { value: "MT", text: "Mato Grosso (MT)" },
  { value: "MS", text: "Mato Grosso do Sul (MS)" },
  { value: "MG", text: "Minas Gerais (MG)" },
  { value: "PA", text: "Pará (PA)" },
  { value: "PB", text: "Paraíba (PB)" },
  { value: "PR", text: "Paraná (PR)" },
  { value: "PE", text: "Pernambuco (PE)" },
  { value: "PI", text: "Piauí (PI)" },
  { value: "RJ", text: "Rio de Janeiro (RJ)" },
  { value: "RN", text: "Rio Grande do Norte (RN)" },
  { value: "RS", text: "Rio Grande do Sul (RS)" },
  { value: "RO", text: "Rondônia (RO)" },
  { value: "RR", text: "Roraíma (RR)" },
  { value: "SC", text: "Santa Catarina (SC)" },
  { value: "SP", text: "São Paulo (SP)" },
  { value: "SE", text: "Sergipe (SE)" },
  { value: "TO", text: "Tocantins (TO)" },
];

export default provinces;
